import { ReactComponent as DEFAULT } from '../../resources/icon/methods/default_symbol.svg';
import { ReactComponent as SGYCP } from '../../resources/icon/methods/SGY-CP.svg';
import { ReactComponent as SGYCU } from '../../resources/icon/methods/SGY-CU.svg';
import { ReactComponent as SGYHE } from '../../resources/icon/methods/SGY-HE.svg';
import { ReactComponent as SGYHP } from '../../resources/icon/methods/SGY-HP.svg';
import { ReactComponent as SGYLY } from '../../resources/icon/methods/SGY-LY.svg';
import { ReactComponent as SGYMW } from '../../resources/icon/methods/SGY-MW.svg';
import { ReactComponent as SGYNO } from '../../resources/icon/methods/SGY-NO.svg';
import { ReactComponent as SGYPA } from '../../resources/icon/methods/SGY-PA.svg';
import { ReactComponent as SGYPO } from '../../resources/icon/methods/SGY-PO.svg';
import { ReactComponent as SGYPI } from '../../resources/icon/methods/SGY-PI.svg';
import { ReactComponent as SGYSI } from '../../resources/icon/methods/SGY-SI.svg';
import { ReactComponent as SGYTR } from '../../resources/icon/methods/SGY-TR.svg';
import { ReactComponent as SGYNE } from '../../resources/icon/methods/SGY-NE.svg';
import { ReactComponent as SGYVP } from '../../resources/icon/methods/SGY-VP.svg';
import { ReactComponent as SGYDTH } from '../../resources/icon/methods/SGY-DTH.svg';
import { ReactComponent as SGYPT } from '../../resources/icon/methods/icon-sgy-casing.svg';
import { ReactComponent as SGYKO } from '../../resources/icon/methods/icon-sgy-test-pit.svg';
import { ReactComponent as SGYDRT } from '../../resources/icon/methods/icon-sgf-rotary-pressure-sounding.svg';
import { ReactComponent as SGYDPSH_A } from '../../resources/icon/methods/icon-tekla-dynamic-probing.svg';
import { ReactComponent as SGYWST } from '../../resources/icon/methods/icon-sgy-weight-sounding.svg';
import { ReactComponent as SGYSU } from '../../resources/icon/methods/icon-sgy-sulfate-soil-sampling.svg';

import { Point } from '../../gql/graphql';
import { FunctionComponent, SVGProps } from 'react';

//Swedish methods
import { ReactComponent as SGFDPSH_A } from '../../resources/icon/methods/methodsSweden/icon-sgf-dynamic-probing.svg';
import { ReactComponent as SGFMWD } from '../../resources/icon/methods/methodsSweden/icon-sgf-mwd.svg';
import { ReactComponent as SGFJb_1 } from '../../resources/icon/methods/methodsSweden/icon-sgf-soil-rock-sounding1.svg';
import { ReactComponent as SGFJb_2 } from '../../resources/icon/methods/methodsSweden/icon-sgf-soil-rock-sounding2.svg';
import { ReactComponent as SGFJb_3 } from '../../resources/icon/methods/methodsSweden/icon-sgf-soil-rock-sounding3.svg';
import { ReactComponent as SGFJb_tot } from '../../resources/icon/methods/methodsSweden/icon-sgf-soil-rock-total-sounding.svg';
import { ReactComponent as SGFTR } from '../../resources/icon/methods/methodsSweden/icon-sgf-pressure-sounding.svg';
import { ReactComponent as SGFDRT } from '../../resources/icon/methods/methodsSweden/icon-sgf-rotary-pressure-sounding.svg';
import { ReactComponent as SGFWST } from '../../resources/icon/methods/methodsSweden/icon-sgf-weight-sounding.svg';
import { ReactComponent as SGFCPT } from '../../resources/icon/methods/methodsNorway/icon-ngf-cone-penetration-test.svg';
//import { ReactComponent as SGFNE } from '../../resources/icon/methods/methodsNorway/icon-ngf-sample-series.svg';
//import { ReactComponent as SGFNO } from '../../resources/icon/methods/SGY-NE.svg';

//Norwegian methods
import { ReactComponent as NGFSS } from '../../resources/icon/methods/methodsNorway/icon-ngf-simple-sounding.svg';
import { ReactComponent as NGFDT } from '../../resources/icon/methods/methodsNorway/icon-ngf-rotary-pressure-sounding.svg';
import { ReactComponent as NGFCPT } from '../../resources/icon/methods/methodsNorway/icon-ngf-cone-penetration-test.svg';
import { ReactComponent as NGFPZ } from '../../resources/icon/methods/methodsSweden/icon-sgf-pore-pressure-measurement.svg';
import { ReactComponent as NGFSA } from '../../resources/icon/methods/methodsNorway/icon-ngf-sample-series.svg';
import { ReactComponent as NGFTOT } from '../../resources/icon/methods/methodsNorway/icon-ngf-norwegian-total-sounding.svg';
//import { ReactComponent as NGFNE } from '../../resources/icon/methods/methodsNorway/icon-ngf-sample-series.svg';
//import { ReactComponent as NGFNO } from '../../resources/icon/methods/SGY-NE.svg';

export enum POINT_STATUS {
    PLANNED = 'PLANNED',
    MEASURED = 'MEASURED'
}

export enum TASKSTATUS {
    OPEN = 'OPEN',
    ASSIGNED = 'ASSIGNED',
    ONGOING = 'ONGOING',
    RESOURCED = 'RESOURCED',
    DONE = 'DONE',
    PAUSED = 'PAUSED',
    CANCELLED = 'CANCELLED',
    FAILED = 'FAILED'
}

export const DEFAULT_TASK_ICON = DEFAULT;

export enum TASK_TYPE_ABBREVIATION {
    //From database
    CP = 'CP',
    LY = 'LY',
    MW = 'MW',
    PI = 'PI',
    PR = 'PR',
    PS = 'PS',
    DT = 'DT',
    VP = 'VP',
    SU = 'SU',
    HE = 'HE',
    PA = 'PA',
    HP = 'HP',
    PO = 'PO',
    NO = 'NO',
    NE = 'NE',
    DTH = 'DTH',
    SI = 'SI',
    CU = 'CU',
    KO = 'KO',
    TR = 'TR',
    PT = 'PT',
    SA = 'SA',
    SS = 'SS',
    DrT = 'DRT',
    PZ = 'PZ',
    CPT = 'CPT',
    CPTU = 'CPTU',
    MWD = 'MWD',
    Jb_1 = 'JB-1',
    Jb_2 = 'JB-2',
    Jb_3 = 'JB-3',
    Jb_tot = 'JB-TOT',
    TOT = 'TOT',
    DPSH_A = 'DPSH-A',
    Tr = 'TR',
    WST = 'WST',
    SLB = 'SLB',
    RF = 'RF',
    RED = 'RED'
}

export const getSGYIcon = (method: string | undefined | null) => {
    if (!method || method.length <= 0) {
        return DEFAULT;
    }
    switch (method.toUpperCase()) {
        case TASK_TYPE_ABBREVIATION.SU:
            return SGYSU;
        case TASK_TYPE_ABBREVIATION.CP:
            return SGYCP;
        case TASK_TYPE_ABBREVIATION.CU:
            return SGYCU;
        case TASK_TYPE_ABBREVIATION.DrT:
            return SGYDRT;
        case TASK_TYPE_ABBREVIATION.DPSH_A:
            return SGYDPSH_A;
        case TASK_TYPE_ABBREVIATION.HE:
            return SGYHE;
        case TASK_TYPE_ABBREVIATION.HP:
            return SGYHP;
        case TASK_TYPE_ABBREVIATION.KO:
            return SGYKO;
        case TASK_TYPE_ABBREVIATION.LY:
            return SGYLY;
        case TASK_TYPE_ABBREVIATION.MW:
            return SGYMW;
        case TASK_TYPE_ABBREVIATION.MWD:
            return SGYMW;
        case TASK_TYPE_ABBREVIATION.NO:
            return SGYNO;
        case TASK_TYPE_ABBREVIATION.PA:
            return SGYPA;
        case TASK_TYPE_ABBREVIATION.PI:
            return SGYPI;
        case TASK_TYPE_ABBREVIATION.PO:
            return SGYPO;
        case TASK_TYPE_ABBREVIATION.PT:
            return SGYPT;
        case TASK_TYPE_ABBREVIATION.SI:
            return SGYSI;
        case TASK_TYPE_ABBREVIATION.TR:
            return SGYTR;
        case TASK_TYPE_ABBREVIATION.NE:
            return SGYNE;
        case TASK_TYPE_ABBREVIATION.VP:
            return SGYVP;
        case TASK_TYPE_ABBREVIATION.DTH:
            return SGYDTH;
        case TASK_TYPE_ABBREVIATION.WST:
            return SGYWST;
        default:
            // console.log('method icon for SGY-' + method + 'is missing');
            return DEFAULT;
    }
};

export const getSGFIcon = (
    method: string | undefined | null
): FunctionComponent<SVGProps<SVGSVGElement> & { title?: string | undefined }> => {
    if (!method || method.length <= 0) {
        return DEFAULT;
    }
    switch (method.toUpperCase()) {
        case TASK_TYPE_ABBREVIATION.DrT:
            return SGFDRT;
        case TASK_TYPE_ABBREVIATION.DPSH_A:
            return SGFDPSH_A;
        case TASK_TYPE_ABBREVIATION.MWD:
            return SGFMWD;
        case TASK_TYPE_ABBREVIATION.WST:
            return SGFWST;
        case TASK_TYPE_ABBREVIATION.Jb_1:
        case TASK_TYPE_ABBREVIATION.SLB:
            return SGFJb_1;
        case TASK_TYPE_ABBREVIATION.Jb_2:
            return SGFJb_2;
        case TASK_TYPE_ABBREVIATION.Jb_3:
            return SGFJb_3;
        case TASK_TYPE_ABBREVIATION.Jb_tot:
            return SGFJb_tot;
        case TASK_TYPE_ABBREVIATION.TOT:
            return NGFTOT;
        case TASK_TYPE_ABBREVIATION.TR:
            return SGFTR;
        case TASK_TYPE_ABBREVIATION.CPT:
        case TASK_TYPE_ABBREVIATION.CPTU:
            return NGFCPT;
        case TASK_TYPE_ABBREVIATION.NE:
            return SGYNE;
        case TASK_TYPE_ABBREVIATION.NO:
            return SGYNO;
        case TASK_TYPE_ABBREVIATION.RED:
            return SGYVP;
        case TASK_TYPE_ABBREVIATION.RF:
            return SGYVP;
        default:
            // console.log('method icon for SGF-' + method + 'is missing');
            return DEFAULT;
    }
};

export const getNGFIcon = (
    method: string | undefined | null
): FunctionComponent<SVGProps<SVGSVGElement> & { title?: string | undefined }> => {
    if (!method || method.length <= 0) {
        return DEFAULT;
    }

    switch (method.toUpperCase()) {
        // SAMPLE_SERIES
        case TASK_TYPE_ABBREVIATION.SA:
            return NGFSA;

        //SIMPLE_SOUNDING
        case TASK_TYPE_ABBREVIATION.SS:
            return NGFSS;

        //ROTARY_PRESSURE_SOUNDING
        case TASK_TYPE_ABBREVIATION.DT:
            return NGFDT;

        // CONE_PENETRATION_TEST
        // CONE_PENETRATION_TEST_WITH_PORE_PRESSURE_MEASUREMENT
        case TASK_TYPE_ABBREVIATION.CPT:
        case TASK_TYPE_ABBREVIATION.CPTU:
            return SGFCPT;

        // PORE_PRESSURE_MEASUREMENT
        case TASK_TYPE_ABBREVIATION.PZ:
            return NGFPZ;

        // NORWEIGIAN_TOTAL_SOUNDING
        case TASK_TYPE_ABBREVIATION.TOT:
            return NGFTOT;

        // SAMPLE_TAKING_UNDISTURBED
        case TASK_TYPE_ABBREVIATION.NE:
            return SGYNE;

        // SAMPLE_TAKING_UNDISTURBED
        case TASK_TYPE_ABBREVIATION.DT:
            return SGYNE;

        case TASK_TYPE_ABBREVIATION.NO:
            return SGYNO;
        case TASK_TYPE_ABBREVIATION.RED:
            return SGYVP;
        case TASK_TYPE_ABBREVIATION.RF:
            return SGYVP;

        default:
            // console.log('method icon for NGF-' + method + 'is missing');
            return DEFAULT;
    }
};

export enum iconState {
    INITIAL = 'OPEN',
    ASSIGNED = 'ASSIGNED',
    DOING = 'ONGOING',
    DONE = 'DONE',
    CANCELLED = 'CANCELLED',
    PAUSED = 'PAUSED',
    RESOURCED = 'RESOURCED',
    FAILED = 'FAILED'
}

export const isDraft = (status: string) => {
    return !status || status == iconState.INITIAL;
};

export const isDone = (status: string) => {
    return status == iconState.DONE;
};

export const isCancelled = (status: string) => {
    return status == iconState.CANCELLED;
};

export const getPoint = (points: Point[]) => {
    if (points && points.length > 0) {
        for (let p = 0; p < points.length; p++) {
            const onePoint = points[p];
            if (onePoint.State == POINT_STATUS.MEASURED) {
                return onePoint;
            }
        }

        return points[0];
    }
    return null;
};
